import { render, staticRenderFns } from "./RssFeedForm.vue?vue&type=template&id=671a7a9a&"
import script from "./RssFeedForm.vue?vue&type=script&lang=ts&"
export * from "./RssFeedForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports